import { QueryHookOptions, useQuery } from '@apollo/client'

import {
  getReferrals,
  getReferralsVariables,
} from '../../../../models/graphqlTypes'
import { PatientReferralListItem } from '../types/patientReferrals.types'
import { GET_PATIENT_REFERRALS } from '../../../../operations/patientReferralOperations'
import { usePaginationData } from '../../../../common/hooks/helper/usePaginationData'

type Options = QueryHookOptions<getReferrals, getReferralsVariables>

type UsePatientReferralsReturn = {
  loading: boolean
  items: PatientReferralListItem[]
  totalItems: number
  hasMoreItems: boolean
  fetchingMore: boolean
  refetch: () => void
  fetchMore: (options: Options) => void
}

export const usePatientReferrals = (
  options: Options
): UsePatientReferralsReturn => {
  const queryResult = useQuery<getReferrals, getReferralsVariables>(
    GET_PATIENT_REFERRALS,
    {
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      ...options,
    }
  )

  return usePaginationData<
    getReferrals,
    getReferralsVariables,
    PatientReferralListItem
  >({
    items: queryResult.data?.getReferrals.items,
    totalItems: queryResult.data?.getReferrals.total,
    queryResult,
  })
}
